import _ from 'lodash';
import React, { Component } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Mapbox from '../shared/components/Mapbox';

import Geocoder from '../shared/components/Geocoder';

import { sagaLoadOrganizations } from '../shared/actions';
import { sagaGetPOIs, sagaCancelGetPOIs, sagaGetBoundaries } from './actions';

import { SAGA_SET_POI_VIEWPORT } from './actions';

import { AUMacro } from '../shared/helpers/boundaries';

const countryOptions = [
  {
    value: 'AU',
    label: 'Australia',
  },{
    value: 'NZ',
    label: 'New Zealand',
  },
];

const customStyles = {
  option: (base, state) => ({
    ...base,
    padding: 20,
    color: 'red',
  }),
  singleValue: (base, state) => {
    return { ...base };
  }
};

const getBoundaryFillColor = (boundaryType) => {
  switch(boundaryType){
    case 'mb':
      return '#32ABE1';
    default:
      return '#32ABE1';
  }
}

class POINetwork extends Component {
  constructor(props){
    super(props);
    this.state = {
      formattedAddress: '',
      bounds: null,
      viewport: {
        topLeft: null,
        bottomRight: null,
      },

      country: 'AU',
      activeMacroGeofence: null,
      organizationFilters: [],

      showOnPremise: true,
      showInPremise: false,
    }
    
    this.onCountryChange = this.onCountryChange.bind(this);
    this.onOrganizationFilterChange = this.onOrganizationFilterChange.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);

    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onRadioboxChange = this.onRadioboxChange.bind(this);
  }
  
  componentDidMount(){
    this.props.getOrganizations(this.state.country);
  }

  componentWillUnmount(){
    this.props.cancelPOILoad();
  }

  onCountryChange(e){
    this.setState({
      country: e.value,
      organizationFilters: [],
    }, () => {
      const { viewport, organizationFilters, country, activeMacroGeofence } = this.state; 

      this.props.getPOIs(viewport.topLeft, viewport.bottomRight, organizationFilters.map((filter) => filter.value), country);

      if (activeMacroGeofence) {
        this.props.getBoundaries(viewport.topLeft, viewport.bottomRight, activeMacroGeofence, country);
      }
    });


  }

  onOrganizationFilterChange(e){
    this.setState({
      organizationFilters: e,
    }, () => {
      this.props.getPOIs(this.state.viewport.topLeft, this.state.viewport.bottomRight, 
        this.state.organizationFilters.map((filter) => filter.value), this.state.country);
    });
  }

  onViewportChange(topLeft, bottomRight){
    this.setState({
      viewport: {
        topLeft,
        bottomRight,
      }
    })

    this.props.getPOIs(topLeft, bottomRight,
      this.state.organizationFilters.map((filter) => filter.value), this.state.country);

    if (this.state.activeMacroGeofence) {
      this.props.getBoundaries(topLeft, bottomRight, this.state.activeMacroGeofence, this.state.country);
    }
  }

  onCheckboxChange(e) {
    const tmp = {...this.state};
    tmp[e.target.id] = e.target.checked;

    this.setState({
      ...tmp,
    });
  }

  onRadioboxChange(e) {
    const tmp = {...this.state};
    tmp[e.target.name] = e.target.value;
    
    this.setState({
      ...tmp,
    }, () => {
      this.props.getBoundaries(this.state.viewport.topLeft, this.state.viewport.bottomRight,
                               this.state.activeMacroGeofence, this.state.country);
    });
  }


  render() {
    const { state, props } = this;

    const organizationOptions = this.props.organizations.filter(organization => organization.country === state.country)
      .map((organization) => ({
        label: organization.name,
        value: organization._id,
      }));

    const markers = this.props.pois.map(poi => ({
      geo: poi.poi.location,
      htmlContent: `<b>${poi.poi.name}</b> - ${poi.poi.formattedAddress}`,
    }));

    let polygons = [];

    this.props.pois.forEach((poi) => {
      if (poi.fences.length > 0) {
        polygons = [...polygons, {
          geo: poi.fences[0].geo,
          color: '#2DE6D5',
        }];
      }
    });

    props.boundaries.forEach((boundary, i) => {
      polygons = [...polygons, {
        geo: boundary.geo,
        color: getBoundaryFillColor(boundary.boundaryType),
      }];
    });

    const { bounds } = state;

    return (
      <div>
        <div className="content-area">
          <div className="container">
            <div style={{ position: 'relative'}}>
              <h3 className="heading">POI Network</h3>
              <h4 className="sub-heading" style={{ marginBottom: 26 }}> View Admin Boundaries and Points Of Interest</h4>
              <div style={{ width: 200, right: 0, top: 0, position: 'absolute' }}>
                <Select options={countryOptions} defaultValue={countryOptions[0]}
                        placeholder="Country" onChange={this.onCountryChange} />
              </div>
            </div>
            <div style={{ width: '100%', height: 400, paddingBottom: 42 }}>
              <Mapbox drawMode={false} editMode={false} 
                      mapBounds={this.state.bounds} mapCenter={null}
                      markers={markers} 
                      polygons={polygons}
                      viewpointChanged={this.onViewportChange} 
                      centerChanged={() => {
                        this.setState({ bounds: null });
                      }} />
            </div>
          </div>
        </div>
        
        <div className="content-area" style={{ marginTop: 16 }}>
          <div className="container" style={{ paddingBottom: 40 }}>
            <div style={{ 
                width: '50%', 
                float: 'left', 
                borderRight: '1px solid rgba(0,0,0,0.18)',
                paddingRight: 42,
              }}>
              <div className="form-field" style={{ width: '100%' }}>
                <Geocoder onResultSelect={(selected) => {
                  console.log(selected);
                  this.setState({
                    location: selected.location,
                    bounds: selected.bounds,
                    formattedAddress: selected.formattedAddress,
                  });
                }} />
              </div>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row'}}>
                <div className="form-field" style={{ flexGrow: 1 }}>
                  <label>Macro Geofences</label>
                  <div className="group" style={{ width: '100%', marginTop: 10 }}>
                      {AUMacro.map((macro, i) => (
                        <div className="radio-field" key={i}>
                          <input type="radio" id={macro.key} name="activeMacroGeofence" 
                                  onChange={this.onRadioboxChange} value={macro.key} />
                          <label htmlFor="activeMacroGeofence">{macro.label}</label>
                        </div>
                      ))}
                      <div style={{ clear: 'both' }}></div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ width: '46%', float: 'right', padding: '0 2em', boxSizing: 'border-box' }}>
              <div className="form-field" style={{ width: '100%' }}>
                <label>Micro Geofences</label>
                <Select options={organizationOptions} placeholder="Organizations"
                        isSearchable={true} isMulti={true} 
                        value={state.organizationFilters}
                        isClearable={false}
                        onChange={this.onOrganizationFilterChange}
                        style={{ width: '100%', paddingBottom: '1em', ...customStyles }}/>
              </div>
              <div className="form-field" style={{ width: '100%'}}>
                <div className="radio-field">
                  <input type="checkbox" id="showInPremise" 
                          checked={state.showInPremise}
                          onChange={this.onCheckboxChange} />
                  <label>POI (In-Premise)</label>
                </div>
                <div className="radio-field">
                  <input type="checkbox" id="showOnPremise" 
                          checked={state.showOnPremise}
                          onChange={this.onCheckboxChange} />
                  <label>POI (On-Premise)</label>
                </div>
              </div>
            </div>
            <div style={{ clear: 'both' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

POINetwork.propTypes = {
  getOrganizations: PropTypes.func,
  getPOIs: PropTypes.func,
  viewportChanged: PropTypes.func,

  topLeft: PropTypes.array,
  bottomRight: PropTypes.array,

  organizations: PropTypes.array,
  pois: PropTypes.array,
  boundaries: PropTypes.array,
};

// Map props to the store

const mapStateToProps = (state) => ({
  organizations: state.shared.getIn(['organizations']),
  topLeft: state.POI.getIn(['topLeft']),
  bottomRight: state.POI.getIn(['bottomRight']),
  pois: state.POI.getIn(['pois']),
  boundaries: state.POI.getIn(['boundaries']),
});

const mapDispatchToProps = (dispatch) => ({
  getOrganizations: (country) => {
    dispatch(sagaLoadOrganizations(country));
  },
  getPOIs: (topLeft, bottomRight, organizationIds, country) => {
    dispatch(sagaGetPOIs(topLeft, bottomRight, organizationIds, country, 0));
  },
  getBoundaries: (topLeft, bottomRight, boundaryType, country) => {
    dispatch(sagaGetBoundaries(topLeft, bottomRight, boundaryType, country, 0));
  },
  viewportChanged: (topLeft, bottomRight) => {
    dispatch({
      type: SAGA_SET_POI_VIEWPORT,
      payload: {
        topLeft,
        bottomRight,
      }
    });
  },
  cancelPOILoad: () => {
    dispatch(sagaCancelGetPOIs());
  }
})

const POINetworkContainer = connect(mapStateToProps,mapDispatchToProps)(POINetwork);

export default POINetworkContainer;



// WEBPACK FOOTER //
// ./src/POI/POINetwork.js